import CodeMirror from 'codemirror'
import Parser from './../Core/Parser/Parser'

(function (CodeMirror) {
    function helper (cm, event, cursor, code) {
        let currentIndent = cm.getLine(cursor.line).search(/\S|$/) / 4
        function autocompleteCb (autocomplete) {
            let indentStr = '\t'.repeat(currentIndent)
            event.preventDefault()
            cm.replaceRange('\n\t' + indentStr + '\n' + indentStr + autocomplete, cursor)
            cm.setCursor({line: cursor.line + 1, ch: indentStr.length + '\t'.length})
        }

        let parser = new Parser({
            config: window.LangConfig,
            autocompleteCb: autocompleteCb
        })
        try {
            parser.autocomplete(cursor.line, code)
        } catch (e) {
            console.log(e)
        }
    }
    function autocomplete (cm, event, options) {
        let cursor = cm.getCursor()
        let line = cm.getLine(cursor.line)
        if (cursor.ch === line.length) {
            helper(cm, event, cursor, cm.getValue())
        }
    }
    CodeMirror.commands.psflexAutocomplete = autocomplete
})(CodeMirror)



// WEBPACK FOOTER //
// ./src/Codemirror/autocomplete.js